import React from "react";
export const BasketContext = React.createContext({
  productsList: [],
  addProduct: () => {},
  removeProduct: () => {},
  increaseAmount: () => {},
  decreaseAmount: () => {},
  clearBasket: ()=> {},
});
